export type IPropsAbout = {
    dataSource : any,
    type ?: string,
};

export const COMPANY_OVERVIEW = "overview";
export const KEY_COMPETITIVE_DIFFERENCIATORS = "diff";